<div class="context-menu-container">
	@for (item of ContextMenuService.contextMenuOptions; track $index) {
		@switch (item.type) {
			@case ('link') {
				<a [routerLink]="item.disabled ? null : item.url" [ngClass]="{ 'disabled-by-permission': item.disabled }">
					<span>
						{{ item.name }}
					</span>
				</a>
			}

			@default {
				<span (click)="item.event()" [ngClass]="{ 'disabled-by-permission': item.disabled }">
					{{ item.name }}
				</span>
			}
		}
	}
</div>
